import { useState } from "react";
import { useSelector } from "react-redux";
import { isLoadingSelector } from "store1/payment/paymentData.slice.selector";
import ManagePayments from "./managePayments";

const ManagePaymentsWrapper = () => {
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const isLoadingPaymentData = useSelector(isLoadingSelector);
    return (
        <ManagePayments
            isLoadingPaymentData={isLoadingPaymentData}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            pageSize={pageSize}
            setPageSize={setPageSize}
        />
    );
};

export default ManagePaymentsWrapper;